import { createElement } from 'react';
import { DialogContent } from './DialogContent';
import { getTitle } from 'components/Dialogs/confirmDeletion/helpers';
import { ModalSize } from '@ardoq/modal';
import { t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

export const getManagedDialogConfig = ({
  numOfComponents,
  numOfReferences,
}: {
  numOfComponents: number;
  numOfReferences: number;
}) => {
  // i18nLocale$.state OK here: snapshot-at-open-time; @ardoq/modal renders confirm() body once and does not re-render on locale change
  const i18nLocale = i18nLocale$.state;
  const title = `${getTitle({
    numOfComponents,
    numOfReferences,
    i18nLocale,
  })} ${t(
    i18nLocale,
    'externallyManaged:confirmDelete.titleSuffix',
    'from external sources'
  )}`;
  const message = createElement(DialogContent, {
    numOfComponents,
    numOfReferences,
    i18nLocale,
  });
  return {
    title,
    text: message,
    modalSize: ModalSize.M,
  };
};
